var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AutoCompleteSelect',{attrs:{"value":_vm.value,"store":_vm.store,"multiple":true,"operators":['in', 'not_in', 'empty'],"placeholder":"Fiziksel Saklama Ortam Kategorisi Seçiniz"},on:{"selectChanged":_vm.selectChanged,"operatorChanged":_vm.operatorChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }